/** Reports shown on the Reports page. Ids are also stored as favorites. */
export const REPORTS = [
    { id: 'monthlyCompanyReports', title: 'Monthly Reports', category: 'Management Reports', visible: (can) => can('MONTHLY_REPORTS', 'VIEW') },
    { id: 'monthlyExpenses', title: 'Monthly Expenses', category: 'Management Reports', visible: (can) => can('MONTHLY_EXPENSES', 'VIEW') },
    { id: 'rateAdjustmentsReport', title: 'Rate Adjustments Report', category: 'General Reports', visible: (can) => can('GENERAL_REPORTS', 'VIEW') },
    { id: 'fleetPerformance', title: 'Operational Report', category: 'General Reports', visible: (can) => can('GENERAL_REPORTS', 'VIEW') },
    { id: 'truckPayments', title: 'Truck Payments', category: 'Equipment Payments', visible: (can) => can('MONTHLY_REPORTS', 'VIEW') },
    { id: 'trailerPayments', title: 'Trailer Payments', category: 'Equipment Payments', visible: (can) => can('MONTHLY_REPORTS', 'VIEW') },
    { id: 'moneyCodeManagement', title: 'EFS Money Code Management', category: 'Expenditures', visible: (can) => can('MONEY_CODES', 'VIEW') },
    { id: 'payableInvoicesManagement', title: 'Maintenance Invoices', category: 'Expenditures', visible: (can) => can('PAYABLE_INVOICES', 'VIEW') },
    { id: 'expenses', title: 'Expenses', category: 'Expenditures', visible: (can) => can('EXPENSES', 'VIEW') },
    { id: 'fuelCardTransactions', title: 'Fuel Card Transactions', category: 'Expenditures', visible: (can) => can('FUEL_TRANSACTIONS', 'VIEW') },
    { id: 'weeklyGrossByTrucks', title: 'Truck Performance', category: 'Performance Reports', visible: (can) => can('PERFORMANCE_REPORTS', 'VIEW') },
    { id: 'weeklyGrossByDispatch', title: 'Dispatch Performance', category: 'Performance Reports', visible: (can) => can('PERFORMANCE_REPORTS', 'VIEW') },
    { id: 'weeklyGrossByTeams', title: 'Team Performance', category: 'Performance Reports', visible: (can) => can('PERFORMANCE_REPORTS', 'VIEW') },
    { id: 'loadsByPeriod', title: 'Loads By Period', category: 'Load Reports', visible: (can) => can('LOAD_REPORTS', 'VIEW') },
    { id: 'invoices', title: 'Invoiced Loads Report', category: 'Load Reports', visible: (can) => can('LOAD_REPORTS', 'VIEW') },
];

export const REPORT_CATEGORIES = [
    'Management Reports',
    'General Reports',
    'Equipment Payments',
    'Expenditures',
    'Performance Reports',
    'Load Reports',
];

const BY_ID = Object.fromEntries(REPORTS.map((report) => [report.id, report]));

/** Menu shortcut path. Prefixed so it does not collide with the Invoices page. */
export const reportMenuPath = (id) => `reports/${id}`;

export const reportIdFromMenuPath = (path) => (
    typeof path === 'string' && path.startsWith('reports/') ? path.slice('reports/'.length) : null
);

export const reportById = (id) => BY_ID[id] || null;

export const reportTitle = (id) => BY_ID[id]?.title || id;

/**
 * Favorites keep their saved order and leave their own category.
 * A favorite the user can no longer open is hidden. Empty categories are dropped.
 */
export const groupReports = (favoriteIds, can) => {
    const visible = REPORTS.filter((report) => report.visible(can));
    const visibleIds = new Set(visible.map((report) => report.id));
    const favorites = (Array.isArray(favoriteIds) ? favoriteIds : [])
        .filter((id) => visibleIds.has(id))
        .map((id) => BY_ID[id]);
    const favoriteSet = new Set(favorites.map((report) => report.id));
    const groups = REPORT_CATEGORIES.map((name) => ({
        name,
        items: visible.filter((report) => report.category === name && !favoriteSet.has(report.id)),
    })).filter((group) => group.items.length > 0);
    return { favorites, groups };
};
